import styled from "styled-components";
import { Action, ActionHandler, ActionLink } from "./types";
import { alpha } from "../../typography";

const actionIsLink = (action: Action): action is ActionLink => {
  return "link" in action;
};
const actionIsHandler = (action: Action): action is ActionHandler => {
  return "handler" in action;
};

const Link = styled.a`
  ${alpha.link.body2};
  :focus {
    outline-offset: 3px;
  }
`;

const ActionButton = styled.button`
  padding: 0px;
  margin: 0px;
  background: transparent;
  border: none;
  cursor: pointer;
  ${alpha.link.body2};
  :focus {
    outline-offset: 3px;
  }
`;

export const ActionComponent = ({ action }: { action: Action }) => {
  if (actionIsLink(action)) {
    return <Link href={action.link}>{action.label}</Link>;
  }
  if (actionIsHandler(action)) {
    return (
      <ActionButton type="button" onClick={action.handler}>
        {action.label}
      </ActionButton>
    );
  }
  return null;
};
